module.exports = __webpack_public_path__ + "e81c35982912106ab7132abfe3fd7d62.png";


//////////////////
// WEBPACK FOOTER
// ./statics/imgs/answer/answer_yinying_bg@2x.png
// module id = 409
// module chunks = 0